import '@web/components/pending-session.css'

/** Reserve the space for session controls without implying they are ready to use. */
export function SessionControlsSkeleton() {
  return (
    <div
      className="session-controls-skeleton"
      aria-label="Loading session controls"
      aria-busy="true"
    >
      <span className="session-skeleton skeleton-pill" aria-hidden="true" />
      <span
        className="session-skeleton skeleton-pill skeleton-short"
        aria-hidden="true"
      />
      <span className="session-skeleton skeleton-square" aria-hidden="true" />
    </div>
  )
}

/** Keep the workspace layout visible until its binding or initial state has loaded. */
export function SessionWorkspaceSkeleton({
  title = 'Workspace',
}: {
  title?: string
}) {
  return (
    <section
      className="session-workspace-skeleton"
      aria-label={`Loading ${title}`}
      aria-busy="true"
    >
      <span className="sr-only">Loading {title}…</span>
      <div className="skeleton-workspace-heading" aria-hidden="true">
        <span className="session-skeleton skeleton-title" />
        <span className="session-skeleton skeleton-pill" />
      </div>
      <div className="skeleton-workspace-grid" aria-hidden="true">
        <div className="session-skeleton skeleton-card" />
        <div className="session-skeleton skeleton-card" />
        <div className="session-skeleton skeleton-card" />
      </div>
      <div className="skeleton-workspace-rows" aria-hidden="true">
        <span className="session-skeleton skeleton-line" />
        <span className="session-skeleton skeleton-line" />
        <span className="session-skeleton skeleton-line" />
        <span className="session-skeleton skeleton-line" />
      </div>
    </section>
  )
}
